import { render } from "./client-email.vue?vue&type=template&id=f31194f8"
import script from "./client-email.vue?vue&type=script&lang=js"
export * from "./client-email.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__